import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeMode = 'light' | 'dark' | 'system';

interface ThemeState {
  mode: ThemeMode;
  setMode: (m: ThemeMode) => void;
  toggle: () => void;
  /** The resolved scheme — never 'system', always concrete. */
  resolved: () => 'light' | 'dark';
}

function systemPrefersDark(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: 'system',
      setMode: (mode) => set({ mode }),
      toggle: () => {
        const current = get().resolved();
        set({ mode: current === 'dark' ? 'light' : 'dark' });
      },
      resolved: () => {
        const m = get().mode;
        if (m === 'system') return systemPrefersDark() ? 'dark' : 'light';
        return m;
      },
    }),
    { name: 'gb-theme' },
  ),
);
